import { AdminApi } from 'stylemix-vue-admin'

export default class VehicleTypeApi extends AdminApi {
  constructor(parameters) {
    super('vehicle-types', parameters)
  }
}
